// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.size-table {
    width: 800px !important;
    padding: 15px;
    max-width: 100% !important;
    color: #000000;
}

.size-table__block {
    margin-bottom: 40px;
}

.size-table__block:nth-last-child {
    margin-bottom: 0;
}

.size-table__button {
    cursor: pointer;
    color: #000000;
    text-decoration: underline;
}

.size-table__title {
    font-size: 20px;
    margin-bottom: 15px;
}

.size-table__data {
    overflow-x: auto;
}

.size-table__table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    font-size: 14px;
}

@media (max-width: 1100px) {
    .size-table__table {
        white-space: nowrap;
        width: auto;
        min-width: 100%;
    }
}

.size-table__table tbody tr:nth-child(2n) {
    background-color: #f0f0f0;
}

.size-table__cell {
    /*width: 100%;*/
    box-sizing: border-box;
    border-bottom: 1px solid #e0e0e0;
    text-align: center;
}

.size-table__cell > div {
    padding: 5px 10px;
    white-space: nowrap;
}

.size-table__cell_inverse {
    color: #ffffff;
    background-color: #333333;
}

.size-table__cell_strong {
    font-weight: bold;
}

.size-table__title_alert {
    color: #dd0000;
}

.size-table__close {
    padding: 5px 0;
    text-align: right;
}

.size-table__close button {
    background-color: #ffffff;
    color: #333333;
}

.size-table__close button:hover {
    background-color: #e0e0e0 !important;
    color: #333333 !important;
}
`, "",{"version":3,"sources":["webpack://./resources/views/site/blocks/measure/style.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,aAAa;IACb,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI;QACI,mBAAmB;QACnB,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B","sourcesContent":[".size-table {\n    width: 800px !important;\n    padding: 15px;\n    max-width: 100% !important;\n    color: #000000;\n}\n\n.size-table__block {\n    margin-bottom: 40px;\n}\n\n.size-table__block:nth-last-child {\n    margin-bottom: 0;\n}\n\n.size-table__button {\n    cursor: pointer;\n    color: #000000;\n    text-decoration: underline;\n}\n\n.size-table__title {\n    font-size: 20px;\n    margin-bottom: 15px;\n}\n\n.size-table__data {\n    overflow-x: auto;\n}\n\n.size-table__table {\n    width: 100%;\n    table-layout: fixed;\n    border-collapse: collapse;\n    font-size: 14px;\n}\n\n@media (max-width: 1100px) {\n    .size-table__table {\n        white-space: nowrap;\n        width: auto;\n        min-width: 100%;\n    }\n}\n\n.size-table__table tbody tr:nth-child(2n) {\n    background-color: #f0f0f0;\n}\n\n.size-table__cell {\n    /*width: 100%;*/\n    box-sizing: border-box;\n    border-bottom: 1px solid #e0e0e0;\n    text-align: center;\n}\n\n.size-table__cell > div {\n    padding: 5px 10px;\n    white-space: nowrap;\n}\n\n.size-table__cell_inverse {\n    color: #ffffff;\n    background-color: #333333;\n}\n\n.size-table__cell_strong {\n    font-weight: bold;\n}\n\n.size-table__title_alert {\n    color: #dd0000;\n}\n\n.size-table__close {\n    padding: 5px 0;\n    text-align: right;\n}\n\n.size-table__close button {\n    background-color: #ffffff;\n    color: #333333;\n}\n\n.size-table__close button:hover {\n    background-color: #e0e0e0 !important;\n    color: #333333 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
